export enum ApiMessagesEnum {
    NpiAlreadyInUse = 'NPI NUMBER ALREADY IN USE.',
    NpiNotValid = 'NPI Number not valid.'
}